import type { IconButtonProps } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import * as React from "react";
import type { PropsWithChildren } from "react";

//eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SimpleIconButtonProps extends IconButtonProps {}

const SimpleIconButton: React.FC<PropsWithChildren<SimpleIconButtonProps>> = ({ children, ...props }) => {
    return (
        <IconButton {...props}>
            <>{children}</>
        </IconButton>
    );
};

export default SimpleIconButton;
